import React, { useEffect, useState, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom'; // PLENARIUM:AJUSTES_2110
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import {
  Plus, Play, Square, Tv, X, ArrowLeft, Lock, Unlock,
  AlertTriangle, Users, Timer, ChevronUp, ChevronDown,
  Printer, UserCheck, FileText, Award, Trash2, ScrollText
} from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import EleicaoMesaAdmin from '../components/EleicaoMesaAdmin'; // PLENARIUM:ELEICAO_MESA
import { BotaoPdfTV } from '../components/MateriaTV'; // PLENARIUM:TV_SOBERANA
import { excluirComConfirmacao } from '../components/ConfirmarExclusao'; // PLENARIUM:LIXEIRA
import JustificativasSessao from '../components/JustificativasSessao'; // PLENARIUM:JUSTIFICATIVA
import ExpedienteAdmin from '../components/ExpedienteAdmin'; // PLENARIUM:LEITURAS
import RetificacoesAta from '../components/RetificacoesAta'; // PLENARIUM:ATA_RETIFICACAO
import { AutorizarMudancaVoto } from '../components/MudancaVoto'; // PLENARIUM:MUDANCA_VOTO
import { TribunaComando } from '../components/Tribuna'; // PLENARIUM:TRIBUNA
import { BotaoEstruturaSessao } from '../components/EstruturaSessao'; // PLENARIUM:ESTRUTURA_SESSAO
import { BotaoSegundaChamada, podeIniciarOrdemDoDia, PainelSegundaChamada, HistoricoPresenca } from '../components/Chamadas'; // PLENARIUM:DUAS_CHAMADAS PLENARIUM:PRESENCA_REGISTRO
import ConducaoSessao, { SecaoFase } from '../components/ConducaoSessao'; // PLENARIUM:CONDUCAO
import { BotaoMateriasTeste, BotaoExpedienteTeste } from '../components/HomologacaoTeste'; // PLENARIUM:HOMOLOGACAO
import { imprimirRoteiroSessao } from '../components/RoteiroSessao'; // PLENARIUM:ROTEIRO_PRO
import { BotaoVotoMesa } from '../components/VotoMesa'; // PLENARIUM:VOTO_MESA

const TIPOS = ['PROJETO_LEI','PROJETO_RESOLUCAO','REQUERIMENTO','MOCAO','INDICACAO','OUTROS','ATA_ANTERIOR'];
const TIPO_LABEL = {
  PROJETO_LEI: 'Projeto de Lei', PROJETO_RESOLUCAO: 'Proj. Resolução',
  REQUERIMENTO: 'Requerimento', MOCAO: 'Moção', INDICACAO: 'Indicação', OUTROS: 'Outros',
  ATA_ANTERIOR: 'Ata da Sessão Anterior'
};
// PLENARIUM:PRESIDENTE_QUORUM -- visual dos cartoes Presidente e Quorum
const CSS_PQ = `
.pq-grade { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 14px; margin-bottom: 16px; }
.pq-card { padding: 16px 18px !important; display: flex; flex-direction: column; gap: 10px; margin: 0 !important; }
.pq-rot { display: flex; align-items: center; gap: 6px; font-size: .7rem; font-weight: 800; letter-spacing: .8px; text-transform: uppercase; color: var(--texto-suave); }
.pq-pres { display: flex; align-items: center; gap: 12px; }
.pq-foto { width: 52px; height: 52px; border-radius: 50%; overflow: hidden; background: rgba(37,99,235,.12); color: var(--acento, #2563eb); display: flex; align-items: center; justify-content: center; font-weight: 800; flex-shrink: 0; border: 2px solid rgba(37,99,235,.25); }
.pq-foto img { width: 100%; height: 100%; object-fit: cover; }
.pq-nome { font-size: 1.05rem; font-weight: 800; color: var(--texto); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pq-nome.vazio { color: var(--texto-suave); }
.pq-sub { font-size: .78rem; color: var(--texto-suave); }
.pq-sub b { color: var(--texto); }
.pq-sel { width: 100% !important; max-width: none !important; }
.pq-nota { font-size: .72rem; color: var(--texto-suave); margin: 0; line-height: 1.45; }
.pq-q { display: flex; align-items: center; gap: 14px; }
.pq-num { display: flex; align-items: baseline; flex-shrink: 0; }
.pq-num b { font-size: 2.2rem; font-weight: 900; line-height: 1; font-variant-numeric: tabular-nums; }
.pq-num span { font-size: 1.1rem; font-weight: 700; color: var(--texto-suave); margin-left: 2px; }
.pq-pill { display: inline-flex; border-radius: 999px; padding: 4px 11px; font-size: .74rem; font-weight: 800; }
.pq-barra { position: relative; height: 8px; border-radius: 999px; background: var(--cinza); }
.pq-enche { position: absolute; left: 0; top: 0; bottom: 0; border-radius: 999px; transition: width .4s; }
.pq-min { position: absolute; top: -4px; width: 2px; height: 16px; background: var(--texto); border-radius: 2px; opacity: .55; transform: translateX(-1px); }
`;

// PLENARIUM:PAUTA_CARD -- rotulo e cores de cada situacao da pauta
const STATUS_PAUTA_INFO = {
  PENDENTE: { rot: 'Aguardando', cor: '#64748b', fundo: 'rgba(100,116,139,.12)' },
  EM_VOTACAO: { rot: 'Em votação', cor: '#dc2626', fundo: 'rgba(220,38,38,.12)' },
  APROVADA: { rot: 'Aprovada', cor: '#15803d', fundo: 'rgba(22,163,74,.13)' },
  REPROVADA: { rot: 'Reprovada', cor: '#b91c1c', fundo: 'rgba(220,38,38,.12)' },
  RETIRADA: { rot: 'Retirada de pauta', cor: '#b45309', fundo: 'rgba(217,119,6,.13)' }
};
const CSS_PAUTA_CARD = `
.pdp-card { padding: 0 !important; overflow: hidden; border-left: 4px solid var(--cinza); transition: box-shadow .15s; }
.pdp-card:hover { box-shadow: 0 6px 18px rgba(15,23,42,.08); }
.pdp-linha { display: flex; align-items: flex-start; gap: 14px; padding: 16px 18px 12px; }
.pdp-marca { display: flex; align-items: center; margin-top: 10px; cursor: pointer; flex-shrink: 0; }
.pdp-marca input { width: 18px; height: 18px; cursor: pointer; accent-color: #1e3a8a; }
.pdp-mover { display: flex; flex-direction: column; gap: 3px; flex-shrink: 0; margin-top: 2px; }
.pdp-mover button { background: none; border: 1px solid var(--cinza); border-radius: 6px; padding: 1px 4px; cursor: pointer; color: var(--texto-suave); line-height: 0; }
.pdp-mover button:disabled { opacity: .3; cursor: not-allowed; }
.pdp-ordem { width: 42px; height: 42px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: .95rem; flex-shrink: 0; font-variant-numeric: tabular-nums; }
.pdp-corpo { flex: 1; min-width: 0; }
.pdp-meta { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; font-size: .72rem; color: var(--texto-suave); margin-bottom: 4px; }
.pdp-tipo { font-weight: 800; text-transform: uppercase; letter-spacing: .6px; color: var(--acento, #4338ca); }
.pdp-num { font-weight: 700; color: var(--texto); }
.pdp-ponto { opacity: .5; }
.pdp-tag { display: inline-flex; align-items: center; gap: 4px; border: 1px solid var(--cinza); border-radius: 999px; padding: 1px 8px; font-weight: 600; }
.pdp-tag.forte { border-color: var(--reprovado); color: var(--reprovado); font-weight: 800; }
.pdp-tit { font-weight: 700; font-size: .95rem; line-height: 1.4; color: var(--texto); margin: 0; overflow-wrap: anywhere; }
.pdp-desc { font-size: .8rem; color: var(--texto-suave); margin: 4px 0 0; line-height: 1.45; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.pdp-status { display: inline-flex; align-items: center; gap: 6px; border-radius: 999px; padding: 5px 12px; font-size: .74rem; font-weight: 800; white-space: nowrap; flex-shrink: 0; letter-spacing: .2px; }
.pdp-pulso { width: 7px; height: 7px; border-radius: 50%; background: currentColor; animation: pdpPulso 1.2s ease infinite; }
@keyframes pdpPulso { 0%,100% { opacity: 1; } 50% { opacity: .25; } }
.pdp-res { padding: 0 18px 14px 74px; }
.pdp-barra { display: flex; height: 8px; border-radius: 999px; overflow: hidden; background: var(--cinza); }
.pdp-barra span { height: 100%; }
.pdp-cont { display: flex; flex-wrap: wrap; gap: 6px 18px; margin-top: 8px; font-size: .8rem; color: var(--texto-suave); }
.pdp-cont b { font-size: .95rem; margin-right: 2px; font-variant-numeric: tabular-nums; }
.pdp-total { margin-left: auto; font-size: .74rem; }
.pdp-acoes { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding: 9px 18px; border-top: 1px solid var(--cinza); background: var(--cinza-claro, rgba(148,163,184,.06)); }
.pdp-link { display: inline-flex; align-items: center; gap: 5px; background: none; border: none; padding: 5px 8px; border-radius: 8px; font: inherit; font-size: .78rem; font-weight: 600; color: var(--texto-suave); cursor: pointer; }
.pdp-link:hover { background: var(--cinza); color: var(--texto); }
.pdp-link.perigo:hover { color: var(--reprovado); }
@media (max-width: 640px) { .pdp-res { padding-left: 18px; } .pdp-linha { flex-wrap: wrap; } .pdp-total { margin-left: 0; } }
`;

const STATUS_PAUTA_BADGE = {
  PENDENTE: 'badge-amarelo', EM_VOTACAO: 'badge-vermelho',
  APROVADA: 'badge-verde', REPROVADA: 'badge-vermelho', RETIRADA: 'badge-cinza'
};

export default function SessaoDetalhe() {
  const { id } = useParams();
  const [sessao, setSessao] = useState(null);
  const [pautas, setPautas] = useState([]);
  const [slotAta, setSlotAta] = useState(null); // PLENARIUM:AJUSTES_2110 -- lugar da ata da sessao anterior (secao 2)
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ numero: '', titulo: '', descricao: '', tipo: 'PROJETO_LEI', votacaoSecreta: false, projetoId: '' });
  const [salvando, setSalvando] = useState(false);
  // Guarda o id quando o modal está corrigindo uma pauta existente.
  const [editandoPauta, setEditandoPauta] = useState(null);
  const [quorum, setQuorum] = useState(null);
  const [presentesReais, setPresentesReais] = useState(0);
  const [modalQuorum, setModalQuorum] = useState(false);
  const [pautaParaIniciar, setPautaParaIniciar] = useState(null);
  const [blocoSel, setBlocoSel] = useState([]); // PLENARIUM:VOTACAO_BLOCO -- materias marcadas
  const [vereadores, setVereadores] = useState([]);
  const [projetos, setProjetos] = useState([]);

  // Presença
  const [modalPresenca, setModalPresenca] = useState(false);
  // PLENARIUM:PRESENCA_REGISTRO -- historico e as duas chamadas no mesmo lugar
  const [histPresenca, setHistPresenca] = useState([]);
  const [duasCh, setDuasCh] = useState(false);
  const [abaPresenca, setAbaPresenca] = useState('1');
  const [presencas, setPresencas] = useState([]);
  const [presencaManual, setPresencaManual] = useState({});
  const [loadingPresenca, setLoadingPresenca] = useState(false);
  // PLENARIUM:PRESENCA_SYNC -- modal aberto acompanha o tablet em tempo real
  const modalPresencaRef = useRef(false); modalPresencaRef.current = modalPresenca;
  const recarregarPresencaRef = useRef(null);

  // Cronômetro
  const [modalCronometro, setModalCronometro] = useState(false);
  const [nomeOrador, setNomeOrador] = useState('');
  const [fotoOrador, setFotoOrador] = useState('');
  const [vereadorSelecionado, setVereadorSelecionado] = useState('');
  const [tempoOrador, setTempoOrador] = useState(3);
  const [cronometroAtivo, setCronometroAtivo] = useState(false);
  const [tempoRestante, setTempoRestante] = useState(0);
  const [cronometroNome, setCronometroNome] = useState('');
  const [cronometroFoto, setCronometroFoto] = useState('');
  const [cronometroPartido, setCronometroPartido] = useState('');
  const [cronometroVereadorId, setCronometroVereadorId] = useState(null);
  const [cronometroPausado, setCronometroPausado] = useState(false);
  const socketRef = useRef(null);

  // >>> PLENARIUM:APARTES estados inicio
  const [usosPalavra, setUsosPalavra] = useState([]);
  const [aparteFala, setAparteFala] = useState(null);      // fala cujos apartes estao sendo marcados
  const [aparteMarcados, setAparteMarcados] = useState({}); // { vereadorId: true }
  const [salvandoApartes, setSalvandoApartes] = useState(false);
  // <<< PLENARIUM:APARTES estados fim

  const carregar = useCallback(async () => {
    try {
      const [sRes, pRes, qRes, vRes, projRes, relRes] = await Promise.all([
        axios.get('/api/sessoes'),
        axios.get(`/api/pautas/sessao/${id}`),
        axios.get(`/api/sessoes/${id}/quorum`),
        axios.get('/api/vereadores'),
        axios.get('/api/projetos'),
        axios.get(`/api/relatorios/sessao/${id}`).catch(() => ({ data: {} }))
      ]);
      setSessao(sRes.data.find(s => s.id === id));
      setPautas(pRes.data);
      setQuorum(qRes.data);
      setVereadores(vRes.data.filter(v => v.ativo));
      setProjetos(projRes.data.filter(p => !['APROVADO','REPROVADO','ARQUIVADO','PROMULGADO'].includes(p.status)));
      setPresentesReais((relRes.data?.presenca || []).filter(p => p.presente).length);
    } catch { toast.error('Erro ao carregar sessão'); }
    finally { setLoading(false); }
  }, [id]);

  // Atualiza a contagem de presentes reais (por votação + registro manual).
  // Usado ao vivo quando chega voto novo ou quando a presença manual muda.
  const atualizarPresentesReais = useCallback(async () => {
    try {
      const rel = await axios.get(`/api/relatorios/sessao/${id}`);
      setPresentesReais((rel.data?.presenca || []).filter(p => p.presente).length);
    } catch {}
  }, [id]);

  useEffect(() => {
    carregar();
    const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    socketRef.current = socket;
    socket.emit('entrar-sala', `sessao-${id}`);
    // PLENARIUM:VOTACAO_BLOCO -- bloco muda varias materias de uma vez: recarrega a lista
    socket.on('pauta-iniciada', (p) => { if (p && p.bloco) { carregar(); return; } setPautas(prev => prev.map(x => x.id === p.id ? p : { ...x, status: x.status === 'EM_VOTACAO' ? 'PENDENTE' : x.status })); });
    socket.on('bloco-atualizado', () => carregar()); // PLENARIUM:VOTO_MESA -- destaque
    socket.on('pauta-encerrada', (p) => { if (p && p.bloco) { carregar(); return; } setPautas(prev => prev.map(x => x.id === p.id ? p : x)); });
    socket.on('sessao-atualizada', (s) => setSessao(prev => prev?.id === s.id ? { ...prev, status: s.status, presidenteId: s.presidenteId } : prev));
    socket.on('pauta-removida', (data) => setPautas(prev => prev.filter(p => p.id !== data.id)));
    socket.on('novo-voto', (data) => setPautas(prev => prev.map(x => {
      if (x.id !== data.pautaId) return x;
      // Votacao secreta: data.voto e null, mas atualiza contagem total
      if (!data.voto) {
        // PLENARIUM:SEGURANCA -- o servidor manda quantos ja votaram
        return { ...x, totalVotos: typeof data.totalVotos === 'number' ? data.totalVotos : (x.totalVotos || 0) + 1 };
      }
      return { ...x, votos: [...(x.votos||[]).filter(v => v.vereadorId !== data.voto.vereadorId), data.voto] };
    })));
    // Quem vota passa a contar como presente — recalcula o quórum ao vivo
    socket.on('novo-voto', () => atualizarPresentesReais());
    // PLENARIUM:PRESENCA_SYNC -- vereador confirmou no tablet (ou outro admin marcou):
    // atualiza o quorum e, se o Controle de Presenca estiver aberto, a lista
    const aoMudarPresenca = () => { atualizarPresentesReais(); if (modalPresencaRef.current && recarregarPresencaRef.current) recarregarPresencaRef.current(); };
    socket.on('presenca-atualizada', aoMudarPresenca);
    socket.on('novo-voto', () => { if (modalPresencaRef.current && recarregarPresencaRef.current) recarregarPresencaRef.current(); });
    // Cronômetro: recebe updates do backend (o timer roda lá, não aqui)
    socket.on('cronometro-update', (data) => {
      if (data.encerrado) {
        setCronometroAtivo(false);
        setCronometroPausado(false);
        setTempoRestante(0);
        if (data.nome) toast('⏰ Tempo do orador encerrado!', { duration: 5000 });
      } else {
        setTempoRestante(data.tempo);
        if (data.iniciado || (data.nome && data.tempo > 0)) {
          setCronometroAtivo(true);
          setCronometroPausado(false);
          setCronometroNome(data.nome || '');
          setCronometroFoto(data.foto || '');
          setCronometroPartido(data.partido || '');
        }
        if (data.pausado !== undefined) setCronometroPausado(data.pausado);
      }
    });
    // Sync: pede o estado do timer SEMPRE que conectar (inclusive depois de
    // um F5 ou de uma reconexão) — emitido solto, disparava antes da conexão.
    socket.on('connect', () => {
      socket.emit('cronometro-sync', { sessaoId: id });
      // Diz ao Painel do Servidor que a mesa está conectada.
      socket.emit('identificar', { tipo: 'admin', nome: 'Mesa' });
    });
    socket.emit('cronometro-sync', { sessaoId: id });
    return () => socket.disconnect();
  }, [id, carregar, atualizarPresentesReais]);

  // Timer removido — o cronômetro agora roda no BACKEND (timerManager.js).
  // O SessaoDetalhe só envia comandos e recebe updates via socket.

  const adicionarTempo = (seg) => {
    socketRef.current?.emit('cronometro-cmd', { cmd: 'add-time', sessaoId: id, segundos: seg });
    toast.success(`+${seg >= 60 ? `${seg / 60}min` : `${seg}s`} adicionado!`);
  };

  const selecionarProjeto = (projetoId) => {
    if (!projetoId) { setForm(f => ({ ...f, projetoId: '', titulo: '', descricao: '', tipo: 'PROJETO_LEI' })); return; }
    const projeto = projetos.find(p => p.id === projetoId);
    if (projeto) {
      setForm(f => ({ ...f, projetoId, titulo: projeto.ementa, descricao: projeto.descricao || '', tipo: projeto.tipo, numero: f.numero || projeto.numero }));
    }
  };

  // PLENARIUM:PRESENCA_SYNC -- presenca confirmada pelo proprio vereador no
  // tablet (manual: false) tambem conta; antes aparecia como "Ausente" aqui.
  // presencaManual[id] = 'MANUAL' (admin marcou) | 'TABLET' (vereador confirmou)
  const lerPresenca = async () => {
    const [relRes, presRes] = await Promise.all([
      axios.get(`/api/relatorios/sessao/${id}`),
      axios.get(`/api/presencas/${id}`)
    ]);
    setPresencas(relRes.data.presenca || []);
    const manual = {};
    (presRes.data || []).forEach(p => { manual[p.vereadorId] = p.manual ? 'MANUAL' : 'TABLET'; });
    setPresencaManual(manual);
    // PLENARIUM:PRESENCA_REGISTRO
    axios.get(`/api/presencas/${id}/historico`).then(r => setHistPresenca(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    axios.get(`/api/chamadas/sessao/${id}`).then(r => setDuasCh(!!(r.data && (r.data.duas || r.data.segunda)))).catch(() => {});
  };
  recarregarPresencaRef.current = () => { lerPresenca().catch(() => {}); };
  const abrirPresenca = async () => {
    setLoadingPresenca(true);
    setModalPresenca(true);
    try { await lerPresenca(); } catch { toast.error('Erro ao carregar presenças'); }
    finally { setLoadingPresenca(false); }
  };

  const togglePresencaManual = async (vereadorId, nomeVereador, jaPresente) => {
    if (jaPresente && !presencaManual[vereadorId]) {
      toast('Este vereador já está presente por votação.', { icon: 'ℹ️' }); return;
    }
    try {
      if (presencaManual[vereadorId]) {
        if (presencaManual[vereadorId] === 'TABLET' && !window.confirm(`${nomeVereador} confirmou no tablet. Retirar a presença dele(a)?\n\nA confirmação original fica guardada no histórico.`)) return; // PLENARIUM:PRESENCA_REGISTRO
        await axios.delete(`/api/presencas/${id}/${vereadorId}`);
        setPresencaManual(prev => { const n = { ...prev }; delete n[vereadorId]; return n; });
        setPresencas(prev => prev.map(p => p.id === vereadorId ? { ...p, presenteManual: false, presente: p.presentePorVoto } : p));
        toast.success(`Presença de ${nomeVereador} removida!`);
      } else {
        await axios.post(`/api/presencas/${id}/${vereadorId}`);
        setPresencaManual(prev => ({ ...prev, [vereadorId]: 'MANUAL' }));
        setPresencas(prev => prev.map(p => p.id === vereadorId ? { ...p, presenteManual: true, presente: true } : p));
        toast.success(`Presença de ${nomeVereador} registrada!`);
      }
      atualizarPresentesReais();
    } catch { toast.error('Erro ao atualizar presença'); }
  };

  const moverPauta = async (index, direcao) => {
    const novaLista = [...pautas];
    const destino = index + direcao;
    if (destino < 0 || destino >= novaLista.length) return;
    [novaLista[index], novaLista[destino]] = [novaLista[destino], novaLista[index]];
    const atualizadas = novaLista.map((p, i) => ({ ...p, ordem: i }));
    setPautas(atualizadas);
    try {
      await axios.patch('/api/pautas/reordenar', { pautas: atualizadas.map(p => ({ id: p.id, ordem: p.ordem })) });
    } catch { toast.error('Erro ao reordenar'); carregar(); }
  };

  const selecionarVereador = (vereadorId) => {
    setVereadorSelecionado(vereadorId);
    if (vereadorId) {
      const v = vereadores.find(v => v.id === vereadorId);
      if (v) { setNomeOrador(v.nome); setFotoOrador(v.fotoUrl || ''); }
    } else { setNomeOrador(''); setFotoOrador(''); }
  };

  const iniciarCronometro = () => {
    const segundos = tempoOrador * 60;
    const vObj = vereadores.find(v => String(v.id) === String(vereadorSelecionado));
    setCronometroNome(nomeOrador);
    setCronometroFoto(fotoOrador);
    setCronometroPartido(vObj?.partido || '');
    setCronometroVereadorId(vereadorSelecionado || null);
    setModalCronometro(false);
    socketRef.current?.emit('cronometro-cmd', {
      cmd: 'start', sessaoId: id, tempo: segundos,
      nome: nomeOrador, foto: fotoOrador,
      partido: vObj?.partido || null, cargo: vObj?.cargo || null,
      vereadorId: vereadorSelecionado || null
    });
    toast.success(`Cronômetro iniciado para ${nomeOrador || 'Orador'}!`);
  };

  const pausarCronometro = () => {
    socketRef.current?.emit('cronometro-cmd', { cmd: 'pause', sessaoId: id });
  };

  const pararCronometro = () => {
    socketRef.current?.emit('cronometro-cmd', { cmd: 'stop', sessaoId: id });
    toast('Cronômetro encerrado');
  };

  const formatarTempo = (seg) => {
    const m = Math.floor(seg / 60).toString().padStart(2, '0');
    const s = (seg % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const mudarStatusSessao = async (status) => {
    try {
      await axios.patch(`/api/sessoes/${id}/status`, { status });
      toast.success(`Sessão ${status === 'EM_ANDAMENTO' ? 'iniciada' : 'encerrada'}!`);
      carregar();
    } catch { toast.error('Erro ao atualizar sessão'); }
  };
  // Quem conduz a sessão declara quando a Ordem do Dia começa. Enquanto
  // não declarar, o Painel TV mostra a chamada de presença.
  const alternarOrdemDoDia = async (iniciada) => {
    try {
      await axios.patch(`/api/sessoes/${id}/ordem-do-dia`, { iniciada });
      toast.success(iniciada ? 'Ordem do Dia iniciada!' : 'Painel voltou para a presença');
      carregar();
    } catch { toast.error('Erro ao atualizar o painel'); }
  };

  const verificarEIniciarVotacao = (pauta) => {
    if (quorum && presentesReais < quorum.quorumMinimo) {
      setPautaParaIniciar(pauta);
      setModalQuorum(true);
    } else { iniciarVotacao(pauta.id); }
  };

  const iniciarVotacao = async (pautaId) => {
    try {
      const res = await axios.patch(`/api/pautas/${pautaId}/iniciar`);
      // Atualiza state local imediatamente sem depender do socket
      setPautas(prev => prev.map(x =>
        x.id === pautaId
          ? { ...x, ...res.data, status: 'EM_VOTACAO' }
          : x.status === 'EM_VOTACAO' ? { ...x, status: 'PENDENTE' } : x
      ));
      toast.success('Votação iniciada!');
      setModalQuorum(false);
      setPautaParaIniciar(null);
    } catch { toast.error('Erro ao iniciar votação'); }
  };

  // >>> PLENARIUM:VOTACAO_BLOCO
  // O admin marca as materias pendentes e abre uma votacao so. Destaque:
  // desmarcar a materia antes de abrir (ela fica pendente para votar sozinha).
  const marcarBloco = (pid) => setBlocoSel(prev => prev.includes(pid) ? prev.filter(x => x !== pid) : [...prev, pid]);
  const iniciarBloco = async (ids) => {
    try {
      await axios.post('/api/pautas/bloco', { pautaIds: ids });
      setBlocoSel([]); setModalQuorum(false); setPautaParaIniciar(null);
      toast.success(`Votação em bloco iniciada (${ids.length} matérias)!`);
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao iniciar a votação em bloco'); }
  };
  const verificarEIniciarBloco = () => {
    const ids = pautas.filter(p => p.status === 'PENDENTE' && blocoSel.includes(p.id)).map(p => p.id);
    if (ids.length < 2) { toast.error('Marque pelo menos duas matérias.'); return; }
    if (quorum && presentesReais < quorum.quorumMinimo) { setPautaParaIniciar({ bloco: true, ids }); setModalQuorum(true); }
    else iniciarBloco(ids);
  };
  // <<< PLENARIUM:VOTACAO_BLOCO

  const retirarPauta = async (pauta) => {
    if (!window.confirm(`Retirar "${pauta.titulo}" da ordem do dia?`)) return;
    try {
      await axios.patch(`/api/pautas/${pauta.id}/retirar`);
      setPautas(prev => prev.map(p => p.id === pauta.id ? { ...p, status: 'RETIRADA' } : p));
      toast.success('Pauta retirada da ordem do dia.');
    } catch { toast.error('Erro ao retirar pauta'); }
  };

  const definirPresidente = async (vereadorId) => {
    try {
      await axios.patch(`/api/sessoes/${id}/presidente`, { presidenteId: vereadorId || null });
      setSessao(prev => ({ ...prev, presidenteId: vereadorId || null }));
      toast.success(vereadorId ? 'Presidente da sessão definido!' : 'Presidente da sessão removido.');
    } catch { toast.error('Erro ao definir presidente da sessão'); }
  };

  const excluirPauta = async (pauta) => {
    const msg = `Excluir permanentemente a pauta "${pauta.numero} — ${pauta.titulo}"?\n\n` +
      `Todos os votos registrados nela serão apagados` +
      (pauta.projetoId ? ' e o projeto vinculado voltará à tramitação em plenário para nova votação' : '') +
      `.\n\nUse isto apenas para corrigir uma votação feita por engano. Pauta já votada pede motivo e senha.`; // PLENARIUM:LIXEIRA
    if (!window.confirm(msg)) return;
    try { // PLENARIUM:LIXEIRA -- pauta ja votada pede motivo + senha
      if (!(await excluirComConfirmacao(`/api/pautas/${pauta.id}`))) return;
      setPautas(prev => prev.filter(p => p.id !== pauta.id));
      toast.success('Pauta excluída.');
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao excluir pauta (apenas administradores podem excluir).'); }
  };

  const encerrarVotacao = async (pauta) => {
    // Buscar votos frescos da API para garantir contagem correta
    let votosAtuais = pauta.votos || [];
    let nSecreta = pauta.totalVotos || 0; // PLENARIUM:SEGURANCA
    try {
      const pRes = await axios.get(`/api/pautas/sessao/${id}`);
      const pautaAtual = pRes.data.find(p => p.id === pauta.id);
      if (pautaAtual?.votos) votosAtuais = pautaAtual.votos;
      if (typeof pautaAtual?.totalVotos === 'number') nSecreta = pautaAtual.totalVotos;
    } catch {}
    // >>> PLENARIUM:SEGURANCA -- votacao secreta: a tela nao conhece o placar;
    // o sistema apura o resultado ao encerrar.
    if (pauta.votacaoSecreta) {
      let presentesS = nSecreta;
      try { const rr = await axios.get(`/api/relatorios/sessao/${id}`); presentesS = (rr.data.presenca || []).filter(p => p.presente).length || nSecreta; } catch {}
      const nBlocoS = pauta.blocoId === pauta.id ? pautas.filter(x => x.blocoId === pauta.id && x.id !== pauta.id && x.status === 'PENDENTE').length : 0;
      const msgS = (nBlocoS ? `VOTAÇÃO EM BLOCO: o resultado vale para as ${nBlocoS + 1} matérias do bloco.\n\n` : '')
        + (nSecreta < presentesS ? `⚠️ ATENÇÃO: Apenas ${nSecreta} de ${presentesS} vereador(es) presente(s) votaram.\n\n` : '')
        + `Votação secreta: ${nSecreta} voto(s) registrado(s). O resultado será apurado pelo sistema ao encerrar.\n\nEncerrar a votação?`;
      if (!window.confirm(msgS)) return;
      try {
        const r = await axios.patch(`/api/pautas/${pauta.id}/encerrar`, { resultado: 'APROVADA' });
        carregar();
        toast.success(`Pauta ${r.data?.status === 'APROVADA' ? '✅ Aprovada' : '❌ Reprovada'}!`);
      } catch (err) { toast.error(err.response?.data?.error || 'Erro ao encerrar votação'); }
      return;
    }
    // <<< PLENARIUM:SEGURANCA
    const sim = votosAtuais.filter(v => v.opcao === 'SIM').length;
    const nao = votosAtuais.filter(v => v.opcao === 'NAO').length;
    const abs = votosAtuais.filter(v => v.opcao === 'ABSTENCAO').length;
    const totalVotos = sim + nao + abs;
    const resultado = sim > nao ? 'APROVADA' : 'REPROVADA';
    // Buscar presentes para verificar se todos votaram
    let totalPresentes = totalVotos;
    try {
      const relRes = await axios.get(`/api/relatorios/sessao/${id}`);
      totalPresentes = (relRes.data.presenca || []).filter(p => p.presente).length || totalVotos;
    } catch {}
    const votaramTodos = totalPresentes > 0 && totalVotos >= totalPresentes;
    // PLENARIUM:VOTACAO_BLOCO -- avisa que o resultado vale para o bloco todo
    const nBloco = pauta.blocoId === pauta.id ? pautas.filter(x => x.blocoId === pauta.id && x.id !== pauta.id && x.status === 'PENDENTE').length : 0;
    const avisoBloco = nBloco ? `VOTAÇÃO EM BLOCO: o resultado vale para as ${nBloco + 1} matérias do bloco.\n\n` : '';
    const msg = avisoBloco + (votaramTodos
      ? `Encerrar votação? Resultado: ${resultado} (SIM: ${sim}, NÃO: ${nao}, ABST: ${abs})`
      : `⚠️ ATENÇÃO: Apenas ${totalVotos} de ${totalPresentes} vereador(es) presente(s) votaram.\n\nDeseja encerrar mesmo assim? Resultado parcial: ${resultado} (SIM: ${sim}, NÃO: ${nao}, ABST: ${abs})`);
    if (!window.confirm(msg)) return;
    try {
      // PLENARIUM:CONFERIR_ENCERRAMENTO -- manda a contagem mostrada na confirmacao
      await axios.patch(`/api/pautas/${pauta.id}/encerrar`, { resultado, contagem: { sim, nao, abs } });
      // A tela do admin nao escuta o aviso de encerramento: sem isto o
      // botao Encerrar continuava aparecendo ate recarregar a pagina.
      carregar();
      toast.success(`Pauta ${resultado === 'APROVADA' ? '✅ Aprovada' : '❌ Reprovada'}!`);
    } catch (err) {
      // PLENARIUM:CONFERIR_ENCERRAMENTO -- chegou voto durante a confirmacao
      if (err.response?.status === 409) { window.alert('⚠️ ' + err.response.data.error); carregar(); }
      else toast.error(err.response?.data?.error || 'Erro ao encerrar votação');
    }
  };

  // Abre o modal já preenchido para corrigir o cadastro da pauta.
  const abrirEdicaoPauta = (p) => {
    setEditandoPauta(p.id);
    setForm({
      numero: p.numero || '',
      titulo: p.titulo || '',
      descricao: p.descricao || '',
      tipo: p.tipo || 'PROJETO_LEI',
      votacaoSecreta: !!p.votacaoSecreta,
      projetoId: ''
    });
    setModal(true);
  };
  const salvarPauta = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      const { projetoId, ...dadosPauta } = form;
      if (editandoPauta) {
        // Vale para pauta já votada: serve para corrigir o cadastro.
        await axios.put(`/api/pautas/${editandoPauta}`, dadosPauta);
        toast.success('Pauta atualizada!');
      } else {
        const pauta = await axios.post('/api/pautas', { ...dadosPauta, sessaoId: id });
        if (projetoId && pauta.data?.id) {
          await axios.patch(`/api/projetos/${projetoId}/vincular-pauta`, { pautaId: pauta.data.id });
        }
        toast.success('Pauta adicionada!');
      }
      setEditandoPauta(null);
      setModal(false);
      setForm({ numero: '', titulo: '', descricao: '', tipo: 'PROJETO_LEI', votacaoSecreta: false, projetoId: '' });
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  // ─────────────────────────────────────────────────────────────
  // ROTEIRO DE CONDUÇÃO DA SESSÃO
  // Texto usado quando a câmara não tem roteiro próprio cadastrado
  // (Câmaras > editar > Roteiro de condução da sessão).
  // ─────────────────────────────────────────────────────────────
  const ROTEIRO_PADRAO = [
    'ROTEIRO DE CONDUÇÃO DA SESSÃO',
    '',
    '{{SESSAO}} — {{CAMARA}}',
    'Data: {{DATA}} às {{HORA}}   |   Presidência: {{PRESIDENTE}}',
    'Quórum: {{QUORUM}}',
    '',
    '════════════════════════════════════════════════',
    '1. ABERTURA',
    '════════════════════════════════════════════════',
    '',
    'PRESIDENTE:',
    '"{{SAUDACAO}} a todos."',
    '',
    '"Primeiramente, quero agradecer a Deus pela oportunidade de estarmos aqui',
    'reunidos para mais uma sessão desta Casa Legislativa."',
    '',
    '"Quero cumprimentar os senhores vereadores e senhoras vereadoras e os',
    'servidores desta Casa."',
    '',
    '"Havendo número legal de vereadores, declaro aberta a {{SESSAO}}',
    'da {{CAMARA}}."',
    '',
    '{{BLOCO_AUSENCIA}}',
    '',
    '════════════════════════════════════════════════',
    '2. PEQUENO EXPEDIENTE',
    '════════════════════════════════════════════════',
    '',
    '"Dando continuidade aos trabalhos, passamos ao Pequeno Expediente."',
    '',
    '──── ATA DA SESSÃO ANTERIOR ────',
    '{{BLOCO_ATA}}',
    '',
    '──── CORRESPONDÊNCIAS, OFÍCIOS E COMUNICADOS ────',
    '',
    '[  ]  HÁ CORRESPONDÊNCIAS A LER',
    '      "Passaremos agora à leitura das correspondências, ofícios e comunicados',
    '      recebidos por esta Casa."',
    '',
    '      1. ____________________________________________________',
    '      2. ____________________________________________________',
    '      3. ____________________________________________________',
    '      4. ____________________________________________________',
    '',
    '[  ]  NÃO HÁ CORRESPONDÊNCIAS A LER',
    '      "Informo que não há correspondências, ofícios ou comunicados a serem',
    '      lidos nesta sessão."',
    '',
    '──── APRESENTAÇÃO DE MATÉRIAS ────',
    '',
    '[  ]  HÁ MATÉRIAS A APRESENTAR',
    '      "Passamos à apresentação das matérias, requerimentos, indicações e',
    '      moções recebidas por esta Casa."',
    '',
    '      1. ____________________________________________________',
    '      2. ____________________________________________________',
    '      3. ____________________________________________________',
    '      4. ____________________________________________________',
    '',
    '[  ]  NÃO HÁ MATÉRIAS A APRESENTAR',
    '      "Informo que não há matérias a serem apresentadas nesta sessão."',
    '',
    '──── CONCESSÃO DA PALAVRA ────',
    '"Dando continuidade ao Pequeno Expediente, concedo a palavra aos nobres colegas',
    'vereadores que desejarem se manifestar, observando o tempo regimental."',
    '',
    '"Concedo a palavra ao(à) vereador(a) ______________________________."',
    'Após cada fala: "Obrigado, vereador(a)."',
    '',
    'Vereadores presentes — marcar quem se inscreve e quem já falou:',
    '{{ORADORES}}',
    '',
    '"Agradeço as manifestações dos nobres colegas."',
    '',
    '════════════════════════════════════════════════',
    '3. GRANDE EXPEDIENTE — TRIBUNA',
    '════════════════════════════════════════════════',
    '',
    '"Encerrado o Pequeno Expediente, passamos ao Grande Expediente."',
    '',
    '"Havendo vereadores inscritos para uso da tribuna, concederemos a palavra',
    'conforme a ordem de inscrição e pelo tempo regimental."',
    '',
    '"Concedo a palavra ao(à) vereador(a) ______________________________."',
    '',
    'Inscritos para a tribuna:',
    '   1. ______________________________________________________',
    '   2. ______________________________________________________',
    '   3. ______________________________________________________',
    '   4. ______________________________________________________',
    '   5. ______________________________________________________',
    '   6. ______________________________________________________',
    '   7. ______________________________________________________',
    '   8. ______________________________________________________',
    '   9. ______________________________________________________',
    '  10. ______________________________________________________',
    '  11. ______________________________________________________',
    '  12. ______________________________________________________',
    '',
    '"Encerrado o Grande Expediente, passaremos à Ordem do Dia."',
    '',
    '════════════════════════════════════════════════',
    '4. ORDEM DO DIA',
    '════════════════════════════════════════════════',
    '',
    '{{ORDEM_ABERTURA}}',
    '',
    '{{BLOCO_PAUTAS}}',
    '',
    '════════════════════════════════════════════════',
    '5. ENCERRAMENTO',
    '════════════════════════════════════════════════',
    '',
    '"Não havendo mais matérias ou assuntos a serem tratados, quero mais uma vez',
    'agradecer a Deus, aos nobres colegas vereadores e aos servidores desta Casa."',
    '',
    '"Que Deus continue nos concedendo sabedoria e discernimento para que possamos',
    'exercer o nosso trabalho sempre buscando o melhor para a nossa população."',
    '',
    '"Agradeço a presença de todos e, sob a proteção de Deus, declaro encerrada a',
    'presente sessão. Muito obrigado e {{DESPEDIDA}} a todos."',
    '',
    'Observações:',
    '_____________________________________________________________',
    '_____________________________________________________________'
  ].join('\n');

  const _pad2 = (n) => String(n).padStart(2, '0');
  // Lê em UTC: assim sai o horário exatamente como foi cadastrado.
  const _dataDoCadastro = (d) => {
    const x = new Date(d);
    return _pad2(x.getUTCDate()) + '/' + _pad2(x.getUTCMonth() + 1) + '/' + x.getUTCFullYear();
  };
  const _horaDoCadastro = (d) => {
    const x = new Date(d);
    return _pad2(x.getUTCHours()) + ':' + _pad2(x.getUTCMinutes());
  };

  const imprimirRoteiro = async () => {
    try {
      const [rDet, rGeral] = await Promise.all([
        axios.get('/api/relatorios/sessao/' + id),
        axios.get('/api/relatorios/geral').catch(() => ({ data: { sessoes: [] } }))
      ]);
      const det = rDet.data;

      const listaPresenca = det.presenca || [];
      const nomesDe = (lista) => lista.length
        ? lista.map(p => p.nome + (p.partido ? ' (' + p.partido + ')' : '')).join(', ')
        : 'nenhum';

      const anteriores = ((rGeral.data && rGeral.data.sessoes) || [])
        .filter(s => s.id !== det.id && new Date(s.data) < new Date(det.data))
        .sort((a, b) => new Date(b.data) - new Date(a.data));
      const ataAnterior = anteriores[0]
        ? anteriores[0].titulo + ' — ' + _dataDoCadastro(anteriores[0].data)
        : 'não há sessão anterior registrada no sistema';

      const pautasTexto = (det.pautas || []).length
        ? (det.pautas || []).map((p, i) => '  ' + (i + 1) + '. ' + p.numero + ' — ' + p.titulo).join('\n')
        : '  Não há matérias pautadas para esta sessão.';

      // No Pequeno Expediente costuma falar todo mundo: a lista ja vem com os
      // presentes, e o presidente marca quem se inscreve e quem ja falou.
      const presentesLista = listaPresenca.filter(p => p.presente);
      const linhasEmBranco = (presentesLista.length
        ? presentesLista.map((p, i) => '  [  ] inscrito   [  ] falou   ' + (i + 1) + '. ' + p.nome + (p.partido ? ' (' + p.partido + ')' : ''))
        : [
            '  [  ] inscrito   [  ] falou   1. ____________________________________',
            '  [  ] inscrito   [  ] falou   2. ____________________________________',
            '  [  ] inscrito   [  ] falou   3. ____________________________________',
            '  [  ] inscrito   [  ] falou   4. ____________________________________',
            '  [  ] inscrito   [  ] falou   5. ____________________________________'
          ]
      ).join('\n');

      const camara = det.camara || {};
      const modelo = (camara.roteiroSessao && camara.roteiroSessao.trim())
        ? camara.roteiroSessao
        : ROTEIRO_PADRAO;

      // Saudação e despedida seguem o horário CADASTRADO da sessão.
      const horaSessao = new Date(det.data).getUTCHours();
      const saudacao = horaSessao < 12 ? 'Bom dia' : (horaSessao < 18 ? 'Boa tarde' : 'Boa noite');
      const despedida = horaSessao < 12 ? 'um bom dia' : (horaSessao < 18 ? 'uma boa tarde' : 'uma boa noite');

      // O sistema sabe se existe sessão anterior: imprime só o texto que se aplica.
      const blocoAta = anteriores[0]
        ? [
            'Ata a ser apreciada: ' + ataAnterior,
            '',
            '"Coloco em discussão a ata da sessão anterior."',
            '"Não havendo quem queira discutir, coloco a ata em votação."',
            '"Os senhores vereadores que a aprovam permaneçam como estão."',
            '"A ata está aprovada."'
          ].join('\n')
        : '"Informo que não há ata de sessão anterior registrada para apreciação nesta sessão. Daremos continuidade aos trabalhos."';

      // Ausências: o sistema sabe QUEM faltou, mas nunca o motivo.
      const ausentes = listaPresenca.filter(p => !p.presente);
      const blocoAusencia = ausentes.length === 0
        ? 'Não há ausências a registrar nesta sessão.'
        : ([
            '"Informo que, na presente sessão, está(ão) ausente(s) o(s) vereador(es) '
              + ausentes.map(p => p.nome).join(', ') + '."',
            '',
            'Justificativas apresentadas (preencher ao lado de cada nome):'
          ].concat(
            ausentes.map((p, i) => '  ' + (i + 1) + '. ' + p.nome + ' — ' + (p.faltaJustificada ? 'falta justificada (aceita pela Mesa)' : '_______________________________________')) // PLENARIUM:JUSTIFICATIVA
          )).join('\n');

      // A abertura da Ordem do Dia muda conforme haja ou não matérias.
      const totalPautas = (det.pautas || []).length;
      const ordemAbertura = totalPautas === 0
        ? '"Senhores vereadores, passamos neste momento à Ordem do Dia. Nesta sessão não temos matérias em pauta."'
        : '"Senhores vereadores, passamos neste momento à Ordem do Dia. Nesta sessão temos '
          + totalPautas + (totalPautas === 1 ? ' matéria em pauta."' : ' matérias em pauta."');

      // Rótulo do tipo, conforme o cadastro da pauta.
      const ROTULO_TIPO = {
        PROJETO_LEI: 'Projeto de Lei',
        PROJETO_RESOLUCAO: 'Projeto de Resolução',
        REQUERIMENTO: 'Requerimento',
        MOCAO: 'Moção',
        INDICACAO: 'Indicação',
        ATA_ANTERIOR: 'Ata da Sessão Anterior',
        OUTROS: 'Matéria'
      };
      const rotuloTipo = (t) => ROTULO_TIPO[t] || 'Matéria';

      // Uma sequência completa de condução para CADA matéria pautada.
      const blocoPautas = totalPautas === 0
        ? 'Não há matérias a serem apreciadas nesta sessão.'
        : (det.pautas || []).map((p, i) => [
            '──── MATÉRIA ' + (i + 1) + ' de ' + totalPautas + ' — ' + rotuloTipo(p.tipo) + ' ────',
            '"Encontra-se pautada a seguinte matéria: ' + rotuloTipo(p.tipo) + ' nº ' + p.numero + ' — ' + p.titulo + '."',
            '"Coloco a matéria em discussão."',
            '"Em votação. Os senhores vereadores já podem registrar seus votos."',
            '"Proclamo o resultado: a matéria foi ______________________."',
            '',
            '[  ]  HOUVE PEDIDO DE VISTA',
            '      "Informo aos senhores vereadores e ao público presente que foi',
            '      apresentado pedido de vista desta matéria. Dessa forma, ela não será',
            '      submetida à votação nesta sessão, permanecendo para análise e seguindo',
            '      posteriormente sua tramitação nesta Casa Legislativa."'
          ].join('\n')).join('\n\n');

      const texto = modelo
        .split('{{CAMARA}}').join(camara.nome || '')
        .split('{{MUNICIPIO}}').join(camara.municipio || '')
        .split('{{SESSAO}}').join(det.titulo || '')
        .split('{{DATA}}').join(_dataDoCadastro(det.data))
        .split('{{HORA}}').join(_horaDoCadastro(det.data))
        .split('{{PRESIDENTE}}').join(det.presidente ? det.presidente.nome : '____________________________')
        .split('{{PRESENTES}}').join(nomesDe(listaPresenca.filter(p => p.presente)))
        .split('{{AUSENTES}}').join(nomesDe(listaPresenca.filter(p => !p.presente)))
        .split('{{QUORUM}}').join(((det.resumoPresenca && det.resumoPresenca.totalPresentes) || 0) + ' de ' + ((det.resumoPresenca && det.resumoPresenca.total) || 0) + ' vereadores presentes')
        .split('{{PAUTAS}}').join(pautasTexto)
        .split('{{ATA_ANTERIOR}}').join(ataAnterior)
        .split('{{SAUDACAO}}').join(saudacao)
        .split('{{DESPEDIDA}}').join(despedida)
        .split('{{BLOCO_ATA}}').join(blocoAta)
        .split('{{BLOCO_AUSENCIA}}').join(blocoAusencia)
        .split('{{ORDEM_ABERTURA}}').join(ordemAbertura)
        .split('{{BLOCO_PAUTAS}}').join(blocoPautas)
        .split('{{ORADORES}}').join(linhasEmBranco);

      const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const brasao = camara.logoUrl
        ? '<img src="' + camara.logoUrl + '" alt="Brasão" style="width:56px;height:56px;object-fit:contain;" />'
        : '';

      const html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Roteiro — ' + esc(det.titulo || '') + '</title>'
        + '<style>'
        + 'body{font-family:Georgia,\'Times New Roman\',serif;padding:36px;max-width:800px;margin:0 auto;color:#111;font-size:13px;line-height:1.7;}'
        + '.cab{text-align:center;border-bottom:2px solid #1a2d5a;padding-bottom:10px;margin-bottom:18px;}'
        + '.corpo{white-space:pre-wrap;}'
        + '@media print{body{padding:16px;}}'
        + '</style></head><body>'
        + '<div class="cab">' + brasao
        + '<div style="font-weight:bold;font-size:15px;">' + esc((camara.nome || '').toUpperCase()) + '</div>'
        + '<div style="font-size:11px;color:#555;">' + esc(camara.municipio || '') + (camara.estado ? ' — Estado do ' + esc(camara.estado) : '') + '</div>'
        + '</div>'
        + '<div class="corpo">' + esc(texto) + '</div>'
        + '</body></html>';

      const win = window.open('', '_blank');
      if (!win) { toast.error('O navegador bloqueou a janela de impressão'); return; }
      win.document.write(html);
      win.document.close();
      setTimeout(() => win.print(), 400);
    } catch (e) {
      toast.error('Não foi possível gerar o roteiro da sessão');
    }
  };
  const imprimirListaPresenca = async () => {
    try {
      const r = await axios.get(`/api/relatorios/sessao/${id}`);
      const { presenca, resumoPresenca, titulo, data, camara } = r.data;
      const linhasVereadores = presenca.map((v, i) => `
        <tr>
          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:13px;">${i + 1}</td>
          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:13px;"><strong>${v.nome}</strong></td>
          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:13px;text-align:center;">${v.partido}</td>
          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:13px;text-align:center;">${v.presente ? '✅ Presente' : v.faltaJustificada ? '📝 Falta justificada' : '❌ Ausente'}${v.presenteManual ? ' <span style="font-size:10px;color:#6b7280;">(manual)</span>' : ''}</td>
          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;width:200px;">&nbsp;</td>
        </tr>
      `).join('');
      const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Lista de Presença — ${titulo}</title>
      <style>body{font-family:Arial,sans-serif;padding:32px;max-width:800px;margin:0 auto;color:#1f2937;}@media print{body{padding:16px;}}table{width:100%;border-collapse:collapse;}th{background:#1a2d5a;color:white;padding:10px 12px;text-align:left;font-size:12px;}</style>
      </head><body>
      <div style="text-align:center;border-bottom:2px solid #1a2d5a;padding-bottom:16px;margin-bottom:24px;">
        <h2 style="color:#1a2d5a;margin:0;font-size:18px;">🏛️ ${camara?.nome || 'Câmara Municipal'}</h2>
        <h3 style="margin:8px 0 4px;font-size:15px;">LISTA DE PRESENÇA</h3>
        <p style="margin:0;font-size:13px;color:#555;">${titulo}</p>
        <p style="margin:4px 0 0;font-size:12px;color:#888;">Data: ${new Date(data).toLocaleDateString('pt-BR', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</p>
      </div>
      <div style="display:flex;gap:20px;margin-bottom:20px;">
        <div style="background:#dcfce7;border-radius:8px;padding:10px 20px;text-align:center;"><div style="font-size:22px;font-weight:800;color:#16a34a;">${resumoPresenca?.totalPresentes || 0}</div><div style="font-size:11px;color:#166534;">Presentes</div></div>
        <div style="background:#fee2e2;border-radius:8px;padding:10px 20px;text-align:center;"><div style="font-size:22px;font-weight:800;color:#dc2626;">${resumoPresenca?.totalAusentes || 0}</div><div style="font-size:11px;color:#991b1b;">Ausentes</div></div>
        <div style="background:#dbeafe;border-radius:8px;padding:10px 20px;text-align:center;"><div style="font-size:22px;font-weight:800;color:#1d4ed8;">${resumoPresenca?.total || 0}</div><div style="font-size:11px;color:#1e40af;">Total</div></div>
      </div>
      <table>
        <thead><tr><th style="width:40px;">#</th><th>Nome do Vereador</th><th style="text-align:center;width:100px;">Partido</th><th style="text-align:center;width:120px;">Presença</th><th style="text-align:center;">Assinatura</th></tr></thead>
        <tbody>${linhasVereadores}</tbody>
      </table>
      <div style="margin-top:40px;display:flex;justify-content:space-between;">
        <div style="text-align:center;width:45%;"><div style="border-top:1px solid #374151;padding-top:8px;font-size:12px;">Presidente da Câmara</div></div>
        <div style="text-align:center;width:45%;"><div style="border-top:1px solid #374151;padding-top:8px;font-size:12px;">Secretário(a)</div></div>
      </div>
      <div style="border-top:1px solid #e5e7eb;padding-top:14px;margin-top:32px;text-align:center;font-size:11px;color:#9ca3af;">
        Documento gerado em ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')} — Câmara Digital
      </div>
      <script>window.onload=()=>window.print();</script>
      </body></html>`;
      const janela = window.open('', '_blank');
      janela.document.write(html);
      janela.document.close();
    } catch { toast.error('Erro ao gerar lista de presença'); }
  };

  // >>> PLENARIUM:APARTES funcoes inicio
  // Falas da sessao (vem do cronometro), com os apartes de cada uma.
  const carregarUsosPalavra = useCallback(async () => {
    try {
      const r = await axios.get(`/api/uso-palavra/sessao/${id}`);
      const lista = Array.isArray(r.data) ? [...r.data] : [];
      lista.sort((a, b) => new Date(a.criadoEm) - new Date(b.criadoEm));
      setUsosPalavra(lista);
    } catch {}
  }, [id]);

  // Carrega ao abrir e recarrega quando o tempo de um orador termina.
  // So ESCUTA o aviso do cronometro; nao envia nada para ele.
  useEffect(() => {
    carregarUsosPalavra();
    const socket = socketRef.current;
    if (!socket) return undefined;
    let espera = null;
    const aoFimDaFala = (data) => {
      if (data && data.encerrado) {
        clearTimeout(espera);
        espera = setTimeout(carregarUsosPalavra, 1500); // da tempo do servidor gravar
      }
    };
    socket.on('cronometro-update', aoFimDaFala);
    return () => { clearTimeout(espera); socket.off('cronometro-update', aoFimDaFala); };
  }, [carregarUsosPalavra]);

  const duracaoFala = (seg) => {
    const t = Math.max(0, Number(seg) || 0);
    const m = Math.floor(t / 60), r = t % 60;
    return m ? `${m} min${r ? ` ${r} s` : ''}` : `${r} s`;
  };

  const abrirApartes = (u) => {
    const marcados = {};
    (u.apartes || []).forEach(a => { marcados[a.vereadorId] = true; });
    setAparteMarcados(marcados);
    setAparteFala(u);
  };

  const salvarApartes = async () => {
    if (!aparteFala) return;
    setSalvandoApartes(true);
    try {
      const vereadorIds = Object.keys(aparteMarcados).filter(k => aparteMarcados[k]);
      const r = await axios.put(`/api/uso-palavra/${aparteFala.id}/apartes`, { vereadorIds });
      setUsosPalavra(prev => prev.map(u => u.id === aparteFala.id ? { ...u, apartes: r.data } : u));
      toast.success('Apartes registrados!');
      setAparteFala(null);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao gravar os apartes');
    } finally { setSalvandoApartes(false); }
  };
  // <<< PLENARIUM:APARTES funcoes fim

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!sessao) return <div>Sessão não encontrada</div>;

  const porcentagemTempo = cronometroAtivo ? (tempoRestante / (tempoOrador * 60)) * 100 : 0;
  const corCronometro = tempoRestante > 60 ? 'var(--aprovado)' : tempoRestante > 30 ? '#d97706' : 'var(--reprovado)';
  const pautasPendentes = pautas.filter(p => p.status === 'PENDENTE');
  // PLENARIUM:VOTACAO_BLOCO
  const liderAberto = pautas.find(x => x.status === 'EM_VOTACAO' && x.blocoId && x.blocoId === x.id) || null;
  const membrosAbertos = liderAberto ? pautas.filter(x => x.blocoId === liderAberto.id && x.id !== liderAberto.id && x.status === 'PENDENTE') : [];
  const blocoMarcadas = pautas.filter(p => p.status === 'PENDENTE' && blocoSel.includes(p.id));

  return (
    <div>
      <div className="page-header">
        <div>
          <Link to="/sessoes" className="back-link"><ArrowLeft size={13} /> Sessões</Link>
          <h1 className="page-title">{sessao.titulo}</h1>
          <p className="page-subtitle">{format(new Date(new Date(sessao.data).getTime() + new Date(sessao.data).getTimezoneOffset() * 60000), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}{/* PLENARIUM:AJUSTES_2110B -- hora como foi cadastrada */} · {pautas.length} pautas</p>
        </div>
      </div>

      <ConducaoSessao sessao={sessao} sessaoId={id} pautas={pautas} onIniciar={() => mudarStatusSessao('EM_ANDAMENTO')} onEncerrar={() => mudarStatusSessao('ENCERRADA')}
        alternarOrdemDoDia={alternarOrdemDoDia} abrirPresenca={abrirPresenca} abrirCronometro={() => setModalCronometro(true)} onListaPresenca={imprimirListaPresenca}
        onRoteiro={async () => { try { const feito = await imprimirRoteiroSessao(id, toast); if (!feito) imprimirRoteiro(); } catch (e) { imprimirRoteiro(); } }} /> {/* PLENARIUM:CONDUCAO -- barra fixa de conducao da sessao */}

      {/* Cronômetro ativo */}
      {cronometroAtivo && (
        <div className="card" style={{ marginBottom: 16, borderLeft: `3px solid ${corCronometro}` }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1 }}>
              {cronometroFoto ? (
                <img src={cronometroFoto} alt={cronometroNome} className="avatar" style={{ width: 48, height: 48, border: `2px solid ${corCronometro}` }} />
              ) : (
                <div className="avatar-placeholder" style={{ width: 48, height: 48, fontSize: '0.9rem', background: corCronometro, color: 'white' }}>
                  {cronometroNome?.split(' ').map(n => n[0]).slice(0,2).join('') || '👤'}
                </div>
              )}
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
                  <Timer size={13} color={corCronometro} />
                  <span style={{ fontSize: '0.72rem', fontWeight: 700, color: corCronometro, textTransform: 'uppercase' }}>
                    {tempoRestante <= 30 ? '⚠️ Tempo acabando!' : 'Orador em fala'}
                  </span>
                </div>
                <p style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 5 }}>{cronometroNome || 'Orador'}</p>
                <div style={{ background: 'var(--cinza)', borderRadius: 999, height: 6, overflow: 'hidden' }}>
                  <div style={{ width: `${porcentagemTempo}%`, height: '100%', background: corCronometro, borderRadius: 999, transition: 'width 1s linear, background 0.3s' }} />
                </div>
              </div>
            </div>
            <div style={{ fontFamily: 'monospace', fontSize: '2.2rem', fontWeight: 800, color: corCronometro, flexShrink: 0 }}>
              {formatarTempo(tempoRestante)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
              {/* Tempo extra */}
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                <span style={{ fontSize: '0.68rem', color: 'var(--texto-suave)', fontWeight: 600 }}>+Tempo:</span>
                {[30, 60, 180].map(seg => (
                  <button key={seg} className="btn btn-secondary btn-sm" onClick={() => adicionarTempo(seg)} style={{ minWidth: 44 }}>
                    {seg < 60 ? `+${seg}s` : `+${seg / 60}min`}
                  </button>
                ))}
                <input
                  type="number" min={1} placeholder="s"
                  title="Digite o tempo em segundos e pressione Enter"
                  style={{ width: 52, padding: '4px 6px', borderRadius: 6, border: '1px solid var(--cinza)', fontSize: '0.75rem', textAlign: 'center' }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && Number(e.target.value) > 0) {
                      adicionarTempo(Number(e.target.value));
                      e.target.value = '';
                    }
                  }}
                />
              </div>
              {/* Pausar / Parar */}
              <div style={{ display: 'flex', gap: 6 }}>
                <button className="btn btn-secondary btn-sm" onClick={pausarCronometro}>
                  {cronometroPausado ? '▶️ Retomar' : '⏸️ Pausar'}
                </button>
                <button className="btn btn-danger btn-sm" onClick={pararCronometro}>⏹️ Parar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SecaoFase id="abertura" n={1} titulo="Abertura e chamada" desc="Presidente da sessão, quórum e presença dos vereadores." /> {/* PLENARIUM:CONDUCAO */}
      {/* >>> PLENARIUM:PRESIDENTE_QUORUM -- Presidente da sessao e quorum lado a lado */}
      {(() => {
        const pres = vereadores.find(v => v.id === sessao.presidenteId);
        const okQ = quorum ? presentesReais >= quorum.quorumMinimo : false;
        const totalQ = quorum ? (quorum.totalVereadores || 0) : 0;
        const pctQ = totalQ ? Math.min(100, Math.round((presentesReais / totalQ) * 100)) : 0;
        const pctMin = totalQ && quorum ? Math.min(100, (quorum.quorumMinimo / totalQ) * 100) : 0;
        return (
          <div className="pq-grade">
            <style>{CSS_PQ}</style>
            <div className="card pq-card">
              <div className="pq-rot"><Award size={14} /> Presidente da sessão</div>
              <div className="pq-pres">
                <span className="pq-foto">{pres && pres.fotoUrl ? <img src={pres.fotoUrl} alt="" /> : (pres ? (pres.nomeParlamentar || pres.nome).split(' ').filter(w => w.length > 2).map(n => n[0]).slice(0, 2).join('').toUpperCase() : <Award size={22} />)}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {pres
                    ? <><div className="pq-nome">{pres.nomeParlamentar || pres.nome}</div><div className="pq-sub">{pres.partido || 'Sem partido'}</div></>
                    : <><div className="pq-nome vazio">Não definido</div><div className="pq-sub">Escolha quem preside os trabalhos</div></>}
                </div>
              </div>
              {sessao.status !== 'ENCERRADA' && (
                <select className="form-input form-select pq-sel" value={sessao.presidenteId || ''} onChange={e => definirPresidente(e.target.value)}>
                  <option value="">{pres ? '— Remover presidente —' : '— Selecione o presidente —'}</option>
                  {vereadores.map(v => <option key={v.id} value={v.id}>{v.nome}{v.partido ? ` (${v.partido})` : ''}</option>)}
                </select>
              )}
              <p className="pq-nota">Preside os trabalhos e vota apenas para desempatar (voto de minerva). Pode ser diferente a cada sessão.</p>
            </div>

            {quorum && (
              <div className="card pq-card">
                <div className="pq-rot"><Users size={14} /> Quórum</div>
                <div className="pq-q">
                  <div className="pq-num"><b style={{ color: okQ ? 'var(--aprovado)' : '#d97706' }}>{presentesReais}</b><span>/{totalQ}</span></div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <span className="pq-pill" style={okQ ? { color: '#15803d', background: 'rgba(22,163,74,.13)' } : { color: '#b45309', background: 'rgba(217,119,6,.14)' }}>{okQ ? 'Quórum atingido' : 'Quórum insuficiente'}</span>
                    <div className="pq-sub" style={{ marginTop: 4 }}>vereador(es) presente(s) · mínimo para votação{/* PLENARIUM:QUORUM_AJUSTE */}: <b>{quorum.quorumMinimo}</b></div>
                  </div>
                </div>
                <div className="pq-barra">
                  <span className="pq-enche" style={{ width: `${pctQ}%`, background: okQ ? 'var(--aprovado)' : '#f59e0b' }} />
                  <span className="pq-min" style={{ left: `${pctMin}%` }} title={`Mínimo: ${quorum.quorumMinimo}`} />
                </div>
                <p className="pq-nota">{okQ ? 'Votações podem ser realizadas.' : `Faltam ${quorum.quorumMinimo - presentesReais} presença(s) para votações válidas. Registre a presença dos vereadores.`}</p>
              </div>
            )}
          </div>
        );
      })()}
      {/* <<< PLENARIUM:PRESIDENTE_QUORUM */}

      {/* PLENARIUM:CONDUCAO -- a Tribuna foi para depois do Expediente */}

      {/* PLENARIUM:MUDANCA_VOTO -- pedidos de mudanca de voto (so aparece se houver) */}
      {sessao.status === 'EM_ANDAMENTO' && <AutorizarMudancaVoto sessaoId={id} modo="admin" />}

      <SecaoFase id="ata" n={2} titulo="Ata da sessão anterior" desc="Lida pelo Secretário (tela Leituras) e votada na lista de matérias. Pedidos de retificação aparecem aqui." /> {/* PLENARIUM:CONDUCAO */}
      {/* PLENARIUM:ATA_RETIFICACAO -- pedidos de retificacao da ata (so aparece se houver) */}
      {sessao.status !== 'ENCERRADA' && <RetificacoesAta />}
      {/* PLENARIUM:AJUSTES_2110 -- a ata da sessao anterior fica AQUI, fora da Ordem do Dia */}
      <div ref={setSlotAta} style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 10 }} />
      {!pautas.some(p => p.tipo === 'ATA_ANTERIOR') && sessao.status !== 'ENCERRADA' && (
        <div className="card" style={{ padding: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', fontSize: '.85rem', color: 'var(--texto-suave)', marginBottom: 10 }}>
          <span>Nenhuma ata incluída nesta sessão.</span>
          <button className="btn btn-secondary btn-sm" onClick={() => { setEditandoPauta(null); setForm(f => ({ ...f, tipo: 'ATA_ANTERIOR' })); setModal(true); }}><Plus size={13} /> Incluir a ata</button>
        </div>
      )}
      {/* PLENARIUM:ATAS_VARIAS -- mais de uma ata na mesma sessao (cada uma com leitura e votacao propria) */}
      {pautas.some(p => p.tipo === 'ATA_ANTERIOR') && sessao.status !== 'ENCERRADA' && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => { setEditandoPauta(null); setForm(f => ({ ...f, tipo: 'ATA_ANTERIOR' })); setModal(true); }}><Plus size={13} /> Incluir outra ata</button>
        </div>
      )}

      <SecaoFase id="expediente" n={3} titulo="Expediente" desc="Matérias, ofícios e comunicações lidos pelo Secretário. Use “Mostrar na TV” em cada item." /> {/* PLENARIUM:CONDUCAO */}
      {/* PLENARIUM:LEITURAS -- Expediente lido pelo Secretario (antes da Ordem do Dia) */}
      <ExpedienteAdmin sessaoId={id} sessaoStatus={sessao.status} projetos={projetos} />
      {sessao.status !== 'ENCERRADA' && <BotaoExpedienteTeste sessaoId={id} />}{/* PLENARIUM:HOMOLOGACAO */}

      <SecaoFase id="tribuna" n={4} titulo="Uso da Tribuna" desc="Inscrições, sorteio e concessão da palavra (Pequeno/Grande Expediente, Expediente e Explicações Pessoais)." /> {/* PLENARIUM:CONDUCAO */}
      {/* PLENARIUM:TRIBUNA -- inscricoes, sorteio e comando da tribuna */}
      {sessao.status === 'EM_ANDAMENTO' ? <TribunaComando sessaoId={id} modo="admin" /> : <div className="card" style={{ padding: 14, color: 'var(--texto-suave)', fontSize: '.85rem' }}>Disponível com a sessão em andamento.</div>}

      <SecaoFase id="ordem" n={5} titulo="Ordem do Dia" desc="Discussão e votação das matérias." /> {/* PLENARIUM:CONDUCAO */}
      {sessao.status !== 'ENCERRADA' && <div style={{ marginBottom: 12 }}><BotaoMateriasTeste sessaoId={id} onFeito={carregar} /></div>}{/* PLENARIUM:HOMOLOGACAO */}
      {/* Pautas */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <h2 style={{ fontSize: '0.95rem', fontWeight: 700 }}>Pautas da Sessão</h2>
          {pautasPendentes.length > 0 && sessao.status === 'AGENDADA' && (
            <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginTop: 2 }}>Use ↑↓ para reordenar as pautas pendentes</p>
          )}
          {pautasPendentes.length > 1 && sessao.status === 'EM_ANDAMENTO' && (
            <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginTop: 2 }}>Para votar em bloco, marque as caixas das matérias e toque em "Votar em bloco".</p>
          )}
        </div>
        {sessao.status !== 'ENCERRADA' && (
          <button className="btn btn-primary btn-sm" onClick={() => { setEditandoPauta(null); setModal(true); }}><Plus size={13} /> Adicionar Pauta</button>
        )}
      </div>

      {/* PLENARIUM:VOTACAO_BLOCO -- barra das materias marcadas */}
      {sessao.status === 'EM_ANDAMENTO' && blocoMarcadas.length > 0 && (
        <div style={{ position: 'sticky', top: 8, zIndex: 5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', background: '#1e3a8a', color: '#fff', borderRadius: 12, padding: '10px 14px', marginBottom: 10, boxShadow: '0 6px 18px rgba(30,58,138,.25)' }}>
          <span style={{ fontWeight: 700, fontSize: '0.85rem' }}>
            {blocoMarcadas.length} matéria{blocoMarcadas.length > 1 ? 's' : ''} marcada{blocoMarcadas.length > 1 ? 's' : ''} para votação em bloco{blocoMarcadas.length < 2 ? ' — marque pelo menos duas' : ''}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setBlocoSel([])}><X size={13} /> Desmarcar</button>
            <button className="btn btn-primary btn-sm" disabled={blocoMarcadas.length < 2} onClick={verificarEIniciarBloco} style={{ background: '#fff', color: '#1e3a8a', borderColor: '#fff' }}><Play size={13} /> Votar em bloco</button>
          </div>
        </div>
      )}

      <style>{CSS_PAUTA_CARD}</style>{/* PLENARIUM:PAUTA_CARD */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {pautas.filter(x => x.tipo !== 'ATA_ANTERIOR').length === 0 && ( // PLENARIUM:AJUSTES_2110
          <div className="card sem-dados"><p>Nenhuma pauta cadastrada.</p></div>
        )}{pautas.map((p, i) => {
          const ehAta = p.tipo === 'ATA_ANTERIOR'; // PLENARIUM:AJUSTES_2110 -- a ata vai para a secao 2
          const nGrupo = pautas.slice(0, i + 1).filter(x => (x.tipo === 'ATA_ANTERIOR') === ehAta).length;
          const sim = p.votos?.filter(v => v.opcao === 'SIM').length || 0;
          const nao = p.votos?.filter(v => v.opcao === 'NAO').length || 0;
          const abs = p.votos?.filter(v => v.opcao === 'ABSTENCAO').length || 0;
          const podeMover = p.status === 'PENDENTE' && sessao.status !== 'ENCERRADA';
          // PLENARIUM:VOTACAO_BLOCO
          const ehLiderAberto = !!liderAberto && p.id === liderAberto.id && membrosAbertos.length > 0;
          const noBlocoAberto = membrosAbertos.some(m => m.id === p.id);
          const votadaEmBloco = !!p.blocoId && (p.status === 'APROVADA' || p.status === 'REPROVADA') && pautas.some(x => x.id !== p.id && x.blocoId === p.blocoId);
          const podeMarcar = sessao.status === 'EM_ANDAMENTO' && p.status === 'PENDENTE' && !noBlocoAberto;
          // >>> PLENARIUM:PAUTA_CARD -- cartao da pauta mais limpo e profissional
          const totalV = sim + nao + abs;
          const pct = (n) => (totalV ? Math.round((n / totalV) * 100) : 0);
          const st = STATUS_PAUTA_INFO[p.status] || STATUS_PAUTA_INFO.PENDENTE;
          const tituloDif = p.titulo && String(p.titulo).trim() !== String(p.numero || '').trim();
          const cartao = (
            <div key={p.id} className="card pdp-card" style={{ borderLeftColor: noBlocoAberto ? 'var(--reprovado)' : st.cor }}>
              <div className="pdp-linha">
                {podeMarcar && (
                  <label title="Marcar para votar em bloco" className="pdp-marca">
                    <input type="checkbox" checked={blocoSel.includes(p.id)} onChange={() => marcarBloco(p.id)} />
                  </label>
                )}
                {podeMover && (
                  <div className="pdp-mover">
                    <button onClick={() => moverPauta(i, -1)} disabled={i === 0} title="Subir"><ChevronUp size={14} /></button>
                    <button onClick={() => moverPauta(i, 1)} disabled={i === pautas.length - 1} title="Descer"><ChevronDown size={14} /></button>
                  </div>
                )}
                <div className="pdp-ordem" style={{ background: st.fundo, color: st.cor }}>{String(nGrupo).padStart(2, '0')}</div>
                <div className="pdp-corpo">
                  <div className="pdp-meta">
                    <span className="pdp-tipo">{TIPO_LABEL[p.tipo] || p.tipo}</span>
                    {p.numero && <><span className="pdp-ponto">•</span><span className="pdp-num">{p.numero}</span></>}
                    {p.votacaoSecreta && <span className="pdp-tag"><Lock size={11} /> Votação secreta</span>}
                    {p.projetoId && <span className="pdp-tag"><FileText size={11} /> Matéria no Trâmite</span>}
                    {ehLiderAberto && <span className="pdp-tag forte">Em bloco · {membrosAbertos.length + 1} matérias</span>}
                    {noBlocoAberto && <span className="pdp-tag forte">No bloco em votação</span>}
                    {votadaEmBloco && <span className="pdp-tag">Votada em bloco</span>}
                  </div>
                  <p className="pdp-tit">{tituloDif ? p.titulo : (p.numero || p.titulo)}</p>
                  {p.descricao && p.descricao !== p.titulo && <p className="pdp-desc">{p.descricao}</p>}
                </div>
                <span className={`pdp-status ${p.status === 'EM_VOTACAO' ? 'vivo' : ''}`} style={{ color: st.cor, background: st.fundo }}>
                  {p.status === 'EM_VOTACAO' && <span className="pdp-pulso" />}{st.rot}
                </span>
              </div>

              {p.votacaoSecreta && p.status === 'EM_VOTACAO' && (
                <div className="pdp-res">{/* PLENARIUM:SEGURANCA -- secreta aberta: so quantos votaram */}
                  <div className="pdp-cont">
                    <span><Lock size={12} style={{ verticalAlign: '-2px' }} /> <b>{p.totalVotos || 0}</b> voto{(p.totalVotos || 0) === 1 ? '' : 's'} registrado{(p.totalVotos || 0) === 1 ? '' : 's'}</span>
                    <span className="pdp-total">o placar aparece ao encerrar</span>
                  </div>
                </div>
              )}
              {totalV > 0 && (
                <div className="pdp-res">
                  <div className="pdp-barra" title={`SIM ${sim} · NÃO ${nao} · ABSTENÇÃO ${abs}`}>
                    {sim > 0 && <span style={{ width: `${pct(sim)}%`, background: 'var(--aprovado)' }} />}
                    {nao > 0 && <span style={{ width: `${pct(nao)}%`, background: 'var(--reprovado)' }} />}
                    {abs > 0 && <span style={{ width: `${pct(abs)}%`, background: '#94a3b8' }} />}
                  </div>
                  <div className="pdp-cont">
                    <span><b style={{ color: 'var(--aprovado)' }}>{sim}</b> Sim</span>
                    <span><b style={{ color: 'var(--reprovado)' }}>{nao}</b> Não</span>
                    <span><b style={{ color: 'var(--texto-suave)' }}>{abs}</b> Abstenção</span>
                    <span className="pdp-total">{totalV} voto{totalV > 1 ? 's' : ''}{p.encerradaEm ? ` · encerrada às ${format(new Date(p.encerradaEm), 'HH:mm')}` : ''}</span>
                  </div>
                </div>
              )}

              <div className="pdp-acoes">
                {sessao.status === 'EM_ANDAMENTO' && p.status === 'PENDENTE' && !noBlocoAberto && (
                  <>
                    <button className="btn btn-primary btn-sm" onClick={() => verificarEIniciarVotacao(p)}><Play size={13} /> Abrir votação</button>
                    <button className="btn btn-secondary btn-sm" onClick={() => retirarPauta(p)} style={{ color: '#d97706', borderColor: '#f3c98b' }}>Retirar de pauta</button>
                  </>
                )}
                {sessao.status === 'EM_ANDAMENTO' && p.status === 'EM_VOTACAO' && (
                  <button className="btn btn-danger btn-sm" onClick={() => encerrarVotacao(p)}><Square size={13} /> Encerrar votação</button>
                )}
                {/* PLENARIUM:VOTO_MESA -- voto pela Mesa (falha no tablet) e destaque de materia do bloco */}
                {sessao.status === 'EM_ANDAMENTO' && <BotaoVotoMesa pauta={p} vereadores={vereadores} />}
                {sessao.status === 'EM_ANDAMENTO' && (noBlocoAberto || ehLiderAberto) && (
                  <button className="btn btn-secondary btn-sm" title="Tira esta matéria do bloco: ela será votada separadamente" onClick={async () => {
                    if (!window.confirm(`Destacar "${p.numero || p.titulo}" do bloco?\n\nEla sai da votação em bloco e volta para a lista, para ser votada separadamente.${ehLiderAberto ? '\n\nOs votos já dados no bloco continuam valendo para as outras matérias.' : ''}`)) return;
                    try { await axios.post(`/api/pautas/${p.id}/destaque`); toast.success('Matéria destacada: será votada separadamente.'); carregar(); }
                    catch (e) { toast.error((e.response && e.response.data && e.response.data.error) || 'Não foi possível destacar.'); }
                  }}>Destacar do bloco</button>
                )}
                {sessao.status === 'EM_ANDAMENTO' && <BotaoPdfTV pauta={p} sessaoId={id} />}{/* PLENARIUM:TV_SOBERANA */}
                <span style={{ flex: 1 }} />
                {/* Editar vale para qualquer pauta, votada ou nao: corrige numero, titulo ou ementa. */}
                <button className="pdp-link" onClick={() => abrirEdicaoPauta(p)} title="Corrigir o cadastro desta pauta"><FileText size={13} /> Editar</button>
                {(p.status === 'APROVADA' || p.status === 'REPROVADA') && (
                  <button className="pdp-link perigo" onClick={() => excluirPauta(p)} title="Excluir a pauta e seus votos (corrigir votação feita por engano)"><Trash2 size={13} /> Excluir</button>
                )}
              </div>
            </div>
          );
          return ehAta ? (slotAta ? createPortal(cartao, slotAta, p.id) : null) : cartao; // PLENARIUM:AJUSTES_2110
        })}
      </div>

      {/* PLENARIUM:ELEICAO_MESA -- secao da eleicao da Mesa Diretora */}
      <EleicaoMesaAdmin sessaoId={id} sessaoStatus={sessao.status} vereadores={vereadores} />

      <SecaoFase id="encerramento" n={6} titulo="Encerramento e registros" desc="Faltas e justificativas, e o registro do uso da palavra." /> {/* PLENARIUM:CONDUCAO */}
      {/* PLENARIUM:JUSTIFICATIVA -- faltas e justificativas */}
      <div style={{ marginTop: 24 }}><JustificativasSessao sessaoId={id} sessaoStatus={sessao.status} /></div>

      {/* >>> PLENARIUM:APARTES secao inicio */}
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 10 }}>
          <div>
            <h2 style={{ fontSize: '0.95rem', fontWeight: 700 }}>Uso da Palavra</h2>
            <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginTop: 2 }}>
              Falas registradas pelo cronômetro. Marque os apartes concedidos em cada fala — eles entram na ata.
            </p>
          </div>
          <button className="btn btn-secondary btn-sm" onClick={carregarUsosPalavra}><Timer size={13} /> Atualizar</button>
        </div>
        {usosPalavra.length === 0 ? (
          <div className="card sem-dados"><p>Nenhum uso da palavra registrado nesta sessão.</p></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {usosPalavra.map((u, i) => (
              <div key={u.id} className="card" style={{ padding: '12px 16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <div style={{ minWidth: 0 }}>
                    <p style={{ fontWeight: 600, fontSize: '0.85rem' }}>
                      {i + 1}. {u.nome}{u.partido ? ` (${u.partido})` : ''}
                    </p>
                    <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginTop: 2 }}>
                      {duracaoFala(u.tempoTotal)}
                      {u.criadoEm ? ` · ${format(new Date(u.criadoEm), 'HH:mm')}` : ''}
                    </p>
                  </div>
                  <button className="btn btn-secondary btn-sm" onClick={() => abrirApartes(u)}>
                    <Users size={13} /> {(u.apartes || []).length ? 'Editar apartes' : 'Marcar apartes'}
                  </button>
                </div>
                {(u.apartes || []).length > 0 && (
                  <p style={{ fontSize: '0.775rem', marginTop: 8, paddingTop: 8, borderTop: '1px solid var(--cinza)' }}>
                    <strong>Apartes:</strong> {u.apartes.map(a => `${a.nome}${a.partido ? ` (${a.partido})` : ''}`).join(', ')}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      {/* <<< PLENARIUM:APARTES secao fim */}

      {/* Modal Presença */}
      {modalPresenca && (
        <div className="modal-overlay" onClick={() => setModalPresenca(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 540 }}>
            <div className="modal-header">
              <h2 className="modal-title"><UserCheck size={16} /> Controle de Presença</h2>
              <button className="btn-modal-close" onClick={() => setModalPresenca(false)}><X size={18} /></button>
            </div>
            <p style={{ fontSize: '0.775rem', color: 'var(--texto-suave)', marginBottom: 14 }}>
              ✅ Presente por votação &nbsp;|&nbsp; 📱 Confirmou no tablet &nbsp;|&nbsp; 🖊️ Registro manual &nbsp;|&nbsp; ❌ Ausente &nbsp;·&nbsp; <b style={{ color: 'var(--aprovado)' }}>atualiza sozinho</b>
            </p>
            {duasCh && ( /* PLENARIUM:PRESENCA_REGISTRO -- as duas chamadas no mesmo lugar */
              <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                {[['1', '1ª chamada', 'abertura da sessão'], ['2', '2ª chamada', 'antes da Ordem do Dia (votação)']].map(([k, t, s]) => (
                  <button key={k} type="button" onClick={() => setAbaPresenca(k)} className="btn btn-sm" style={{ flex: 1, flexDirection: 'column', alignItems: 'flex-start', border: '2px solid ' + (abaPresenca === k ? '#1d4ed8' : 'var(--cinza)'), background: abaPresenca === k ? '#eff6ff' : '#fff', color: '#0f172a', fontWeight: 800 }}>{t}<small style={{ fontWeight: 600, color: 'var(--texto-suave)' }}>{s}</small></button>
                ))}
              </div>
            )}
            {duasCh && abaPresenca === '2' ? <div style={{ maxHeight: 420, overflowY: 'auto' }}><PainelSegundaChamada sessaoId={id} modo="admin" /></div> : loadingPresenca ? (
              <div style={{ textAlign: 'center', padding: 28 }}><div className="spinner" /></div>
            ) : (
              <div style={{ maxHeight: 380, overflowY: 'auto' }}>
                {presencas.map(v => {
                  const manual = presencaManual[v.id];
                  const porVoto = v.presentePorVoto;
                  const presente = porVoto || manual;
                  return (
                    <div key={v.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid var(--cinza)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        {v.fotoUrl ? <img src={v.fotoUrl} alt={v.nome} className="avatar" style={{ width: 34, height: 34 }} /> : <div className="avatar-placeholder" style={{ width: 34, height: 34, fontSize: '0.75rem' }}>{v.nome?.split(' ').map(n => n[0]).slice(0,2).join('')}</div>}
                        <div>
                          <p style={{ fontWeight: 600, fontSize: '0.825rem' }}>{v.nome}</p>
                          <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)' }}>{v.partido}</p>
                          <HistoricoPresenca itens={histPresenca} vereadorId={v.id} chamada={1} />{/* PLENARIUM:PRESENCA_REGISTRO */}
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '0.72rem', color: presente ? 'var(--aprovado)' : 'var(--reprovado)', fontWeight: 600 }}>
                          {porVoto ? '✅ Por votação' : manual === 'TABLET' ? '📱 Confirmou no tablet' : manual ? '🖊️ Manual' : v.faltaJustificada ? '📝 Falta justificada' : '❌ Ausente'}
                        </span>
                        {!porVoto && (
                          <button className={`btn btn-sm ${manual ? 'btn-danger' : 'btn-secondary'}`} onClick={() => togglePresencaManual(v.id, v.nome, porVoto)}>
                            {manual ? 'Remover' : '+ Registrar'}
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <div style={{ marginTop: 14, padding: '10px 0 0', borderTop: '1px solid var(--cinza)', display: duasCh && abaPresenca === '2' ? 'none' : 'flex', gap: 16, fontSize: '0.8rem' }}>{/* PLENARIUM:PRESENCA_REGISTRO */}
              <span style={{ color: 'var(--aprovado)', fontWeight: 700 }}>✅ Presentes: {presencas.filter(v => v.presentePorVoto || presencaManual[v.id]).length}</span>
              <span style={{ color: 'var(--reprovado)', fontWeight: 700 }}>❌ Ausentes: {presencas.filter(v => !v.presentePorVoto && !presencaManual[v.id]).length}</span>
            </div>
            <div className="modal-actions" style={{ marginTop: 10 }}>
              <button className="btn btn-secondary" onClick={() => setModalPresenca(false)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Cronômetro */}
      {modalCronometro && (
        <div className="modal-overlay" onClick={() => setModalCronometro(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <div className="modal-header">
              <h2 className="modal-title"><Timer size={16} /> Cronômetro de Orador</h2>
              <button className="btn-modal-close" onClick={() => setModalCronometro(false)}><X size={18} /></button>
            </div>
            {fotoOrador && (
              <div style={{ textAlign: 'center', marginBottom: 14 }}>
                <img src={fotoOrador} alt={nomeOrador} className="avatar" style={{ width: 72, height: 72, border: '3px solid var(--acento)' }} />
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Selecionar Vereador (opcional)</label>
              <select className="form-input form-select" value={vereadorSelecionado} onChange={e => selecionarVereador(e.target.value)}>
                <option value="">— Orador externo —</option>
                {vereadores.map(v => <option key={v.id} value={v.id}>{v.nome} ({v.partido})</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Nome do Orador</label>
              <input className="form-input" value={nomeOrador} onChange={e => setNomeOrador(e.target.value)} placeholder="Ex: Ver. João Silva" />
            </div>
            {!vereadorSelecionado && (
              <div className="form-group">
                <label className="form-label">Foto do Orador (opcional)</label>
                <input type="file" accept="image/*" className="form-input" onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  if (file.size > 2 * 1024 * 1024) { alert('Foto deve ter no máximo 2MB!'); return; }
                  const reader = new FileReader();
                  reader.onload = () => setFotoOrador(reader.result);
                  reader.readAsDataURL(file);
                }} />
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Tempo</label>
              <select className="form-input form-select" value={tempoOrador} onChange={e => setTempoOrador(Number(e.target.value))}>
                {[1,2,3,4,5,10,15,20].map(t => <option key={t} value={t}>{t} minuto{t > 1 ? 's' : ''}</option>)}
              </select>
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setModalCronometro(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={iniciarCronometro}>▶️ Iniciar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Adicionar Pauta */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">{editandoPauta ? 'Editar Pauta' : 'Adicionar Pauta'}</h2>
              <button className="btn-modal-close" onClick={() => setModal(false)}><X size={18} /></button>
            </div>
            <form onSubmit={salvarPauta}>
              {/* O vínculo com projeto só faz sentido ao criar: na edição o
                  operador quer corrigir texto, não trocar a origem da pauta. */}
              {!editandoPauta && projetos.length > 0 && (
                <div className="form-group">
                  <label className="form-label">📂 Vincular a projeto existente (opcional)</label>
                  <select className="form-input form-select" value={form.projetoId} onChange={e => selecionarProjeto(e.target.value)}>
                    <option value="">— Criar pauta sem projeto vinculado —</option>
                    {projetos.map(p => <option key={p.id} value={p.id}>{p.numero} — {p.ementa} ({p.autor})</option>)}
                  </select>
                  {form.projetoId && <p style={{ fontSize: '0.72rem', color: 'var(--aprovado)', marginTop: 3 }}>✅ Dados preenchidos automaticamente pelo projeto selecionado</p>}
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Número *</label>
                  <input className="form-input" value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} placeholder="001/2026" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo *</label>
                  <select className="form-input form-select" value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
                    {TIPOS.map(t => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">Título *</label>
                  <input className="form-input" value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })} required />
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">Descrição / Ementa</label>
                  <textarea className="form-input" rows={3} value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })} style={{ resize: 'vertical' }} />
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="checkbox" id="secreta" checked={form.votacaoSecreta} onChange={e => setForm({ ...form, votacaoSecreta: e.target.checked })} />
                  <label htmlFor="secreta" style={{ cursor: 'pointer', fontSize: '0.825rem' }}><Lock size={12} style={{ display: 'inline', marginRight: 4 }} /> Votação secreta</label>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* >>> PLENARIUM:APARTES modal inicio */}
      {aparteFala && (() => {
        // Vereadores ativos da casa, menos o proprio orador. Quem ja estava
        // marcado e hoje esta inativo continua aparecendo, para nao sumir.
        const opcoes = vereadores
          .filter(v => v.id !== aparteFala.vereadorId)
          .map(v => ({ id: v.id, nome: v.nome, partido: v.partido }));
        (aparteFala.apartes || []).forEach(a => {
          if (!opcoes.some(o => o.id === a.vereadorId)) opcoes.push({ id: a.vereadorId, nome: a.nome, partido: a.partido });
        });
        const qtd = Object.keys(aparteMarcados).filter(k => aparteMarcados[k]).length;
        return (
          <div className="modal-overlay" onClick={() => !salvandoApartes && setAparteFala(null)}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
              <div className="modal-header">
                <h2 className="modal-title"><Users size={16} /> Apartes</h2>
                <button className="btn-modal-close" onClick={() => setAparteFala(null)} disabled={salvandoApartes}><X size={18} /></button>
              </div>
              <p style={{ fontSize: '0.8rem', marginBottom: 12 }}>
                Durante a fala de <strong>{aparteFala.nome}{aparteFala.partido ? ` (${aparteFala.partido})` : ''}</strong>, quem fez aparte?
              </p>
              <div style={{ maxHeight: 360, overflowY: 'auto' }}>
                {opcoes.length === 0 ? (
                  <p style={{ fontSize: '0.8rem', color: 'var(--texto-suave)' }}>Nenhum outro vereador cadastrado.</p>
                ) : opcoes.map(v => (
                  <label key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid var(--cinza)', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={!!aparteMarcados[v.id]}
                      onChange={e => setAparteMarcados(prev => ({ ...prev, [v.id]: e.target.checked }))}
                      disabled={salvandoApartes}
                    />
                    <span style={{ fontSize: '0.825rem', fontWeight: 600 }}>{v.nome}</span>
                    {v.partido && <span style={{ fontSize: '0.72rem', color: 'var(--texto-suave)' }}>{v.partido}</span>}
                  </label>
                ))}
              </div>
              <div className="modal-actions" style={{ marginTop: 14 }}>
                <button className="btn btn-secondary" onClick={() => setAparteFala(null)} disabled={salvandoApartes}>Cancelar</button>
                <button className="btn btn-primary" onClick={salvarApartes} disabled={salvandoApartes}>
                  {salvandoApartes ? 'Salvando...' : `Salvar (${qtd})`}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
      {/* <<< PLENARIUM:APARTES modal fim */}

      {/* Modal Quórum */}
      {modalQuorum && pautaParaIniciar && (
        <div className="modal-overlay" onClick={() => setModalQuorum(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
            <div style={{ textAlign: 'center', padding: '4px 0 14px' }}>
              <AlertTriangle size={44} color="var(--pendente)" style={{ margin: '0 auto 14px', display: 'block' }} />
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: 8 }}>Atenção: Quórum Insuficiente</h2>
              <p style={{ color: 'var(--texto-suave)', fontSize: '0.825rem', marginBottom: 6 }}>
                São necessários <strong>{quorum?.quorumMinimo}</strong> vereadores presentes para uma votação válida, mas há apenas <strong>{presentesReais}</strong> presente(s).
              </p>
              <p style={{ color: 'var(--texto-suave)', fontSize: '0.825rem', marginBottom: 20 }}>Deseja iniciar a votação mesmo assim?</p>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => { setModalQuorum(false); setPautaParaIniciar(null); }}>Cancelar</button>
                <button className="btn btn-warning" style={{ flex: 1 }} onClick={() => (pautaParaIniciar.bloco ? iniciarBloco(pautaParaIniciar.ids) : iniciarVotacao(pautaParaIniciar.id))}>Iniciar Mesmo Assim</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}